import { render, staticRenderFns } from "./functionalItem2.vue?vue&type=template&id=7fc142e0&scoped=true"
import script from "./functionalItem2.vue?vue&type=script&lang=js"
export * from "./functionalItem2.vue?vue&type=script&lang=js"
import style0 from "./functionalItem2.vue?vue&type=style&index=0&id=7fc142e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc142e0",
  null
  
)

export default component.exports